import React from "react";
import { v4 as uuid } from "uuid";

import { usePlayContext } from "../../pages/Play/play-context";
import styles from "./action-lines.module.scss";
import { useActionPath } from "./hooks";
import { BlockMarker } from "./markers";
import { ActionLineProps } from "./types";

export const BlockLine = ({ action, controlPoints, strokeWidth = 0.3, animateable = false }: ActionLineProps) => {
  const { color = "#000" } = action;
  const markerEndId = uuid();

  const { pathsWithScales, endTime } = useActionPath({ action, controlPoints });

  const { animationTimerApi } = usePlayContext();
  const { effectiveTime: time } = animationTimerApi;

  return (
    <>
      <BlockMarker id={markerEndId} color={color} />
      {pathsWithScales.map((path, i) => (
        <g key={i}>
          <path
            d={path.pathString}
            className={styles.actionLine}
            {...(i === pathsWithScales.length - 1 && { markerEnd: `url(#block-${markerEndId})` })}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeDasharray={`10000 10000`}
            strokeDashoffset={animateable ? path.scale(time) : 0}
            opacity={animateable && endTime && time >= endTime ? 0.2 : 1}
          />
          <path
            d={path.pathString}
            className={styles.actionLine}
            stroke={color}
            strokeWidth={strokeWidth}
            opacity={0.2}
          />
        </g>
      ))}
    </>
  );
};
